var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { providerType } from '@repo/shared/types';
import { isPragmaPromoted } from './is-pragma-promoted';
import { isLiberisPromoted } from './is-liberis-promoted';
function areCurrentProviderEqual(providerArray, responseProviderArray) {
    if (providerArray.length !== responseProviderArray.length)
        return false;
    var sortedProviderArray = __spreadArray([], providerArray, true).sort();
    var sortedResponseProviderArray = __spreadArray([], responseProviderArray, true).sort();
    return sortedProviderArray.every(function (val, index) { return val === sortedResponseProviderArray[index]; });
}
export var areAllProviderNotPromoted = function (merchantResponse) {
    return (areCurrentProviderEqual([providerType.enum.pragma, providerType.enum.liberis], merchantResponse.currentProvider) &&
        !isPragmaPromoted(merchantResponse) &&
        !isLiberisPromoted(merchantResponse));
};
